import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MonitoringRoutingModule } from './monitoring-routing.module';
import { MaterialModule } from '@reenstudio/app/material.module';
import { PeaksComponent } from './components/peaks/peaks.component';
import { ConsumiComponent } from './components/consumi/consumi.component';
import { MonitoringPageComponent } from './pages/monitoring-page/monitoring-page.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { WeatherComponent } from '@reenstudio/app/shared/components/weather/weather.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { WidgetsComponent } from './components/widgets/widgets.component';
import { ProducedEnergyComponent } from '@reenstudio/app/shared/components/produced-energy/produced-energy.component';
import { ConsumedEnergyComponent } from '@reenstudio/app/shared/components/consumed-energy/consumed-energy.component';
import { ScoreComponent } from '@reenstudio/app/shared/components/score/score.component';
import { SharedModule } from '@reenstudio/app/shared/shared.module';
import { TablerIconsModule } from 'angular-tabler-icons';

@NgModule({
  declarations: [MonitoringPageComponent, PeaksComponent, ConsumiComponent],
  imports: [
    CommonModule,
    MonitoringRoutingModule,
    MaterialModule,
    NgApexchartsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    WeatherComponent,
    NgxSkeletonLoaderModule,
    WidgetsComponent,
    ProducedEnergyComponent,
    ConsumedEnergyComponent,
    ScoreComponent,
    SharedModule,
    TablerIconsModule,
  ],
})
export class MonitoringModule {}
